// IMPORTANT: Initialize Sentry before any other imports
import './sentry';

import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

if (import.meta.env.DEV) {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001';
  console.log(`[Daily Reveal] ${import.meta.env.MODE} mode | API: ${apiUrl}`);
}

createRoot(document.getElementById('root')!).render(<App />);
